import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <div className="contact-container container">
      <div className="contact-content">
        <h1>Let's get in touch!</h1>

        <p className="mb-5">
          If you have a project opportunity, collaboration idea, or would like
          to connect, feel free to send me a message.
        </p>

        <form
          className="contact-form"
          action="https://formspree.io/f/YOUR_FORM_ID"
          method="POST"
        >
          <input type="text" name="name" placeholder="Your Name" required />

          <input type="email" name="email" placeholder="Your Email" required />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="6"
            required
          ></textarea>

          <button type="submit" className="btn btn-branding">
            Send Message
          </button>
        </form>

        <div className="contact-links mt-5">
          <h3>Email</h3>

          <p>
            <a href="mailto:linahmoramaga@gmail.com">linahmoramaga@gmail.com</a>
          </p>

          <h3>GitHub</h3>

          <p>
            <a
              href="https://github.com/lmoramaga"
              target="_blank"
              rel="noopener noreferrer"
            >
              github.com/lmoramaga
            </a>
          </p>

          <h3>LinkedIn</h3>

          <p>
            <a
              href="https://www.linkedin.com/in/lmoramaga/"
              target="_blank"
              rel="noopener noreferrer"
            >
              linkedin.com/in/lmoramaga
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
